import createCache from '../../utils/createCache';

export default function createFetchService(jokiInstance, initOptions = {}) {
    // const options = Object.assign({}, { protocol: "https", serverUrl: "localhost", port: "8080" }, initOptions);
    const serviceId = 'FetchService';
    const joki = jokiInstance;

    let authData = null;

    const abortContainer = new Map();

    const Cache = createCache({ lifetime: 10000 });

    function messageHandler(event) {
        // event.to === serviceId && console.log('FetchService Event', event);
        switch (event.key) {
            case 'request':
                return requestFromServer(event.body);
            case 'cachedRequest':
                return cachedRequest(event.body);
            case 'abortRequest':
                return abortServerRequest(event.body);
            default:
                break;
        }
    }

    function cachedRequest(opts) {
        const method = opts.method !== undefined ? opts.method : 'GET';
        if (method !== 'GET') {
            return requestFromServer(opts);
        }

        return new Promise((resolve, reject) => {
            const cacheKey = opts.url;
            const cacheStatus = Cache.status(cacheKey);

            switch (cacheStatus) {
                case 'VALID':
                    resolve(Cache.get(cacheKey));
                    break;

                case 'FETCHING':
                    Cache.wait(cacheKey)
                        .then(results => {
                            resolve(results);
                        })
                        .catch(() => {
                            requestFromServer(opts)
                                .then(results => {
                                    resolve(results);
                                })
                                .catch(err => {
                                    reject(err);
                                });
                        });
                    break;
                case 'INVALID':
                default:
                    requestFromServer(opts)
                        .then(results => {
                            resolve(results);
                        })
                        .catch(err => {
                            reject(err);
                        });
                    break;
            }
        });
    }

    function abortServerRequest(abortId = null) {
        if (abortId !== null && abortContainer.has(abortId)) {
            abortContainer.get(abortId)();
            abortContainer.delete(abortId);
            return true;
        }
        return false;
    }

    function requestFromServer(opts) {
        // console.warn("fetchService:request", opts);

        if (authData === null) {
            getAuthData();
        }

        if (authData === null) {
            return new Promise((resolve, reject) => {
                reject('Not authorized');
            });
        }

        const fetchOptions = {
            headers: {
                'Content-Type': opts.contentType !== undefined ? opts.contentType : 'text/json',
                Authorization: `Bearer ${authData.access_token}`,
                mode: 'cors',
                cache: 'no-cache',
            },
            method: opts.method !== undefined ? opts.method : 'GET',
        };

        if (typeof opts.mode === 'string') {
            fetchOptions.headers.mode = opts.mode;
        }

        if (opts.doDoubleCall !== true) {
            fetchOptions.body = opts.body !== undefined ? (typeof opts.body !== 'string' ? JSON.stringify(opts.body) : opts.body) : null;
        }

        if (typeof opts.abortId === 'string') {
            const abController = new AbortController();
            fetchOptions.signal = abController.signal;

            abortContainer.set(opts.abortId, () => {
                // console.warn(`ABORTING: ${opts.abortId}! \n\n\n\n`);
                abController.abort();
            });
        }

        if (opts.dummy === true) {
            return dummyFetch(opts.url, fetchOptions, opts);
            // return dummyFetch(`${process.env.REACT_APP_API_URL}/v3/${opts.url}`, fetchOptions, opts);
        }

        // return fetch(`${process.env.REACT_APP_API_URL}/v3/${opts.url}`, fetchOptions)
        if (fetchOptions.method === 'GET' && fetchOptions.body !== undefined) {
            if (fetchOptions.body !== null && fetchOptions.body !== undefined && fetchOptions.body !== 'null') {
                console.warn(`${serviceId}:requestFromServer: When fetching with GET method, there cannot be a body\nurl:${opts.url}\nbody`, fetchOptions.body);
            }
            delete fetchOptions.body;
        }

        // eslint-disable-next-line no-undef
        return fetch(opts.url, fetchOptions)
            .then(response => {
                // console.log("RESPONSE", response);
                return response.json();
            })
            .then(data => {
                if (typeof opts.abortId === 'string') {
                    abortContainer.delete(opts.abortId);
                }

                // console.log("DATA", data);
                if (opts.doDoubleCall === true) {
                    const newopts = { ...opts, doDoubleCall: false };
                    // console.log("New Opts", newopts, data);
                    return requestFromServer(newopts);
                }
                return data;
            })
            .catch(err => {
                console.error(`${serviceId}:requestFromServer: ERROR in REQUEST`, err);
                throw err;
            });
    }

    function dummyFetch(url, fetchOpts, options) {
        return new Promise((resolve, reject) => {
            // console.log(
            //     `\nDUMMY FETCH ${options.doDoubleCall === true ? "Pre-fetch" : ""} \n\turl: ${url} \n\tmethod: ${
            //         fetchOpts.method
            //     } \n\theader: ${fetchOpts.headers["Content-Type"]} \n\t\t${fetchOpts.headers.Authorization} \n\t\t${
            //         fetchOpts.headers.cache
            //     } \n\tbody:`,
            //     fetchOpts.body
            // );

            if (options.doDoubleCall === true) {
                const newOpts = { ...options, doDoubleCall: false };
                return requestFromServer(newOpts);
            }

            if (options.dummyResponse !== undefined) {
                resolve(options.dummyResponse);
                return;
            }

            resolve();
        });
    }

    function getAuthData() {
        const response = joki.ask({
            to: 'AuthenticationService',
            key: 'getAuthData',
            syncAsk: true,
        });
        if (response.AuthenticationService !== undefined) {
            authData = response.AuthenticationService;
        }
    }

    joki.addService({
        id: serviceId,
        fn: messageHandler,
    });
}
